import enGB from './en-GB';
import itIT from './it-IT';
export var AvailableLanguages;
(function (AvailableLanguages) {
    AvailableLanguages["itIT"] = "it-IT";
    AvailableLanguages["enGB"] = "en-GB";
})(AvailableLanguages || (AvailableLanguages = {}));
export const messages = {
    'it-IT': itIT,
    'en-GB': enGB,
};
export default messages;
